<template>
  <!--招标文件及公告-->
  <div>
    <el-card
      v-for="(item, index) of dataList"
      :key="index"
      class="box-card"
      v-show="!item.showFlag || showFlagList.includes(item.showFlag)"
      style="margin-bottom: 10px"
    >
      <div slot="header" class="clearfix">
        <span>{{ item.title }}</span>
      </div>
      <template>
        <el-form label-width="175px" class="form viewFormWrapper" style="margin-bottom: 10px">
          <el-row>
            <el-col v-for="(ite, ind) of item.list" :key="ind" :span="ite.span || 12">
              <el-form-item :label="ite.label">
                <span>{{ changValue(item, ite) }} {{ ite.unit }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </el-card>

    <el-card class="box-card" style="margin-bottom: 10px">
      <div slot="header" class="clearfix">
        <span>电子招标文件</span>
      </div>
      <template>
        <el-button type="primary" size="mini" @click.stop="buttonClick()" :underline="false"> 查看电子招标文件 </el-button>
      </template>
    </el-card>
    <el-card class="box-card" style="margin-bottom: 10px" v-if="(detail.projectCategoryCode==='1' || detail.projectCategoryCode==='2') && detail.tenderScope==='1'">
      <div slot="header" class="clearfix">
        <span>招标文件AI检测</span>
      </div>
      <template>
        <el-form class="form viewFormWrapper" label-width="175px" style="margin-bottom: 10px">
          <el-row :span="20">
            <el-col :span="12">
              <el-form-item label="检测状态：">
                <span>{{ detail.detectStatusName || '-' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="检测完成时间：">
                <span>{{ detail.detectCompletTime || '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button type="primary" size="mini" @click.stop="buttonViewClick()" :underline="false"> 查看检测结果 </el-button>
      </template>
    </el-card>

    <el-card v-show="showFlagList.includes('2')" class="box-card" style="margin-bottom: 10px">
      <div slot="header" class="clearfix">
        <span>邀请潜在投标人</span>
      </div>
      <template>
        <el-table
          stripe
          :header-cell-style="{ background: '#E8E8E8', color: 'rgba(0, 0, 0, 0.85)' }"
          :data="detail.bidderList"
          border
          style="width: 100%"
        >
          <el-table-column width="50" label="序号" type="index" :index="indexMethodNoPage" align="center"></el-table-column>
          <el-table-column prop="bidderName" align="center" label="邀请投标人名称"> </el-table-column>
          <el-table-column prop="qualifyLevel" align="center" label="资质等级"> </el-table-column>
          <el-table-column prop="inviteState" align="center" width="180" label="邀请状态"> </el-table-column>
        </el-table>
      </template>
    </el-card>

    <!-- 附件数据 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>附件信息</span>
      </div>
      <template>
        <div id="affixDown" v-if="attachmentList.length > 0">
          <affix-doc
            v-for="(item, index) in attachmentList"
            :item.sync="item"
            :index="index"
            :key="index"
            labelWidth="200px"
            :name="item.titleName"
          ></affix-doc>
        </div>
        <p style="text-align: center" v-if="attachmentList.length == 0">暂无附件数据</p>
      </template>
    </el-card>

    <el-dialog :visible.sync="imgDialogVisible" width="100%" height="100%" @closed="dialogClose">
      <img :src="filePath" alt="" @contextmenu.prevent="" class="viewImg" />
    </el-dialog>
    <el-dialog :visible.sync="pdfDialogVisible" width="100%" height="100%" @closed="dialogClose">
      <iframe :src="pdfViewer + filePath" frameborder="0" width="100%" height="500" @contextmenu.prevent=""></iframe>
    </el-dialog>
  </div>
</template>

<script>
import affixDoc from "@/components/affixDoc";
import $ from "jquery";
import qs from "qs";
import { projectRegisterEnumList } from "./components/enum";
import {apiurgeconfirmsaveBylist} from "@/server/msg";

export default {
  components: {
    affixDoc,
  },
  props: {
    nodeCode: {
      type: String,
      defalut: "GC00014",
    },
    businessType: {
      type: String,
      defalut: "",
    },
    title: {
      type: String,
      defalut: "",
    },
    categoryCode: {
      type: String,
      defalut: "",
    },
    total: {
      type: Number,
      defalut: 0,
    },
    // 变更历史
    hisListData: {
      type: Array,
      default: () => [],
    },
    dataListLoading: {
      type: Boolean,
      defalut: false,
    },
    // 是否支持附件类别约束
    categoryIsOpen: {
      type: Boolean,
      defalut: false,
    },
  },
  watch: {
    nodeCode: {
      immediate: true,
      handler(val) {
        this.nodeCodeCopy = val;
      },
      deep: true,
    },
    hisListData: {
      immediate: true,
      handler(val) {
        this.hisListDataCopy = val;
      },
      // 这里是关键，代表递归监听 demo 的变化
      deep: true,
    },
  },
  data() {
    return {
      keywords: "",
      pdfViewer: "/pdf/web/viewer.html?file=",
      pageSize: 10, //每页条数
      pageIndex: 1, //当前页
      projectInfo: {},
      tableDataCopy: [],
      attachmentList: [],
      hisListDataCopy: [],
      filePath: "",
      imgDialogVisible: false,
      pdfDialogVisible: false,
      nodeCodeCopy: "",
      dataList: projectRegisterEnumList,
      detail: {
        gcProjectPlanVo: {},
      },
      /**
       * 招标方式
       * 公开招标 招标方式        1
       * 邀请招标        招标方式        2
       * 其它        招标方式        9
       */
      showFlagList: [],
      yesOrNoList: [
        { label: "否", value: 0 },
        { label: "是", value: 1 },
      ],
      dataObj: {},
    };
  },
  activated() {},
  created() {
    this.pdfViewer = (process.env.VUE_APP_proxybaseurl || "") + this.pdfViewer;
  },
  methods: {
    buttonViewClick() {
      if(this.detail.detectId && this.detail.detectStatus === 3){
        let aiBaseURL = process.env.VUE_APP_BIDDING_DOCS_AI || '/bidding-docs-ai';
        window.open(`${aiBaseURL}/deepseek/detail?checkId=${this.detail.detectId||''}`)
      }else{
        if(this.detail.detectStatus === 4){
          this.$confirm('当前文件检测失败，请联系系统服务人员，以人工方式重新进行检测。','提示',{
            confirmButtonText: '确定',
            showCancelButton: false,
            type: 'warning'
          }).then(()=>{}).catch(()=>{})
          return
        }
        this.$confirm('未完成检测，请等待。一般AI检测时间需30分钟左右，若长时间未完成，则可联系系统服务人员。','提示',{
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning'
        }).then(()=>{}).catch(()=>{})
      }
    },
    buttonClick() {
      const data = this.dataObj;
      const params = {
        entityId: data.entityId,
        bidSectionCode: data.bidSectionCode,
        datasetCode: data.datasetCode,
      };
      this.$http.get(`/bidSection/getTenderFileUrl?${qs.stringify(params)}`).then((res) => {
        if (res.data.code === "1") {
          window.open(res.data.data, "_target");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    changValue(item, ite) {
      if (ite.isYesOrNo) {
        const obj = this.yesOrNoList.find((it) => it.value == this.detail[ite.dataIndex]);
        const objStr = obj && obj.label ? obj.label : this.detail[ite.dataIndex];
        return objStr;
      }
      if (item.twoWord) {
        return this.detail[item.twoWord][ite.dataIndex];
      }
      return this.detail[ite.dataIndex];
    },
    dialogClose() {
      this.dialogImageUrl = "";
      this.imgDialogVisible = false;
      this.pdfDialogVisible = false;
    },
    indexMethodNoPage(index) {
      return index + 1;
    },
    isAssetTypeAnImage(ext) {
      let arr = ["png", "jpg", "jpeg", "bmp", "gif", "webp", "psd", "svg", "tif", "tiff"];
      return arr.indexOf(ext.toLowerCase()) !== -1;
    },
    isAssetTypeAnPDF(ext) {
      let arr = ["pdf", "PDF"];
      return arr.indexOf(ext.toLowerCase()) !== -1;
    },
    fileView(item) {
      // 获取文件类型
      let type = item.extendName.substr(item.extendName.lastIndexOf(".") + 1);
      if (!type) {
        type = item.filePath.substr(item.filePath.lastIndexOf(".") + 1);
      }
      let imgFlag = this.isAssetTypeAnImage(type);
      let pdfFlag = this.isAssetTypeAnPDF(type);

      if (pdfFlag) {
        this.imgDialogVisible = false;
        this.pdfDialogVisible = true;
        this.filePath = item.filePath;
        return;
      }

      if (imgFlag) {
        this.$http({
          method: "POST",
          url: `/attachment/getAttachmentByCiteIdAndFileType?bizid=${item.bizId}&fileType=${item.fileType}`,
        }).then((res) => {
          if (res.data.code == "1") {
            this.filePath = res.data.data.filePath;
            this.imgDialogVisible = true;
            this.pdfDialogVisible = false;
          }
        });
      } else {
        this.fileDownload(item);
      }
    },
    fileDownload(item) {
      if (item.filePath) {
        this.$http({
          method: "get",
          url: `/attachment/downloadFile?businessId=${item.bizId}&fileType=${item.fileType}&id=${item.id}`,
          // responseType:'blob'
        }).then((res) => {
          if (res.data.code === "1") {
            var a = document.createElement("a");
            a.download = item.name;
            a.target = "_Blank";
            a.href = res.data.data;
            $("body").append(a);
            a.click();
            $(a).remove();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
      }
    },

    getDetail(data) {
      if (data) {
        this.dataObj = data;
        const params = {
          entityId: data.entityId,
          bidSectionCode: data.bidSectionCode,
        };
        this.$http.get(`/tenderDoc/getDocAndBulletin?${qs.stringify(params)}`).then(({ data }) => {
          if (data.code == "1" && data.data) {
            this.detail = data.data || {};
            this.showFlagList = [data.data.tenderMode];
            // this.getAttachments(data.data.id || "");
            this.getAttachments(this.dataObj.entityId || "");
          }
        });
      } else {
        this.showFlagList = [];
        this.detail = {};
        this.attachmentList = [];
      }
    },

    // 查询附件
    getAttachments(entityId) {
      if (!this.categoryIsOpen) {
        // 不支持附件类别约束
        this.$http.get(`/attachment/getAttachmentByBizId?bizid=${entityId}`).then(({ data }) => {
          if (data.code == "1") {
            this.attachmentList = data.data || [];
            this.attachmentList.forEach((item) => {
              item.titleName = "相关附件";
            });
          } else {
            this.attachmentList = [];
          }
        });
      } else {
        this.$http.get(`/attachment/getDataByCodeAndEid?categoryCode=${this.categoryCode}&entityId=${entityId}`).then(({ data }) => {
          if (data.code == "1") {
            let resData = data.data;
            if (JSON.stringify(resData) !== "{}") {
              const type = this.showFlagList.includes("1") ? ["invitation_1"] : ["notice_1", "7"];
              // console.log('fileList', resData);
              const result = resData.filter((item) => !type.includes(item.fileType));

              console.log("result", result); 

              result.forEach((v) => {
                v.titleName = v.name;
              });
              this.attachmentList = result;
            } else {
              this.attachmentList = [];
            }
          } else {
            this.attachmentList = [];
          }
        });
      }
    },

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.$emit("queryCustomFormData", { pageSize: this.pageSize, pageIndex: this.pageIndex, keywords: this.keywords });
    },
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.$emit("queryCustomFormData", { pageSize: this.pageSize, pageIndex: this.pageIndex, keywords: this.keywords });
    },
  },
};
</script>

<style lang="less" scoped>
.dataWrapper {
  position: relative;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  &:last-child {
    border-bottom: none;
  }
  .iconToolbar-left {
    font-weight: bold;
    color: #fff;
    text-align: center;
    padding-top: 3px;
    position: absolute;
    top: 10px;
    left: 0px;
    width: 32px;
    height: 32px;
    background: url("../../assets/img/bookmark.png") no-repeat;
  }
}
.dataWrapper:last-child {
  border-bottom: none;
}
</style>
